import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({ providedIn: 'root' })
export class AccountDimensionSettingService extends BaseService {
  protected baseUrl = '/basis/catalog/account-dimension-setting';

  public get dropdownDescriptorUrl(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }
}
